import React, { Component } from 'react';
import Toggle from 'material-ui/Toggle';

class TableToggle extends Component {
  render() {
    return (
      <Toggle
        label={this.props.toggleVerbiage}
        labelPosition="right"
        style={{ marginTop: '10px' }}
        onToggle={this.props.toggleAction}
      />
    );
  }
}

export default TableToggle;
